import { createSlice } from '@reduxjs/toolkit';
import { clearReducers } from 'redux/logout';

export const initialState = {
  items: [],
  loaded: true,
  pageable: {
    pageSize: 10,
    pageNumber: 0,
    totalElements: 0,
  },
  status: '',
  search: '',
  type: '',
  marketplaceId: '',
  date: {
    from: '',
    to: '',
  },
};

const packagesHistorySlice = createSlice({
  name: 'packages-history',
  initialState,
  reducers: {
    fetch: (state) => {
      state.loaded = false;
    },
    success: (state, action) => {
      state.loaded = true;
      state.items = action.payload.items;
      state.pageable.totalElements = action.payload.total;
    },
    failure: (state) => {
      state.loaded = true;
    },
    fetchForCsv: (state) => {
      state.loaded = false;
    },
    fetchForCsvSuccess: (state, action) => {
      state.csvItems = action.payload;
      state.loaded = true;
    },
    fetchForCsvFailure: (state) => {
      state.loaded = true;
    },
    updatePagination: (state, action) => {
      state.pageable.pageNumber =
        action.payload.pageSize !== state.pageable.pageSize
          ? 0
          : action.payload.pageNumber;
      state.pageable.pageSize = action.payload.pageSize;
    },
    updateSearch: (state, action) => {
      state.search = action.payload;
      state.pageable.pageNumber = 0;
    },
    updateStatus: (state, action) => {
      state.status = action.payload;
      state.pageable.pageNumber = 0;
    },
    updateDate: (state, action) => {
      state.date = action.payload;
      state.pageable.pageNumber = 0;
    },
    updatePackageType: (state, action) => {
      state.type = action.payload;
      state.pageable.pageNumber = 0;
    },
    resetFetchedDates: (state) => {
      state.fetchedDates = {};
    },
    updatePacket: (state, action) => {
      const index = state.items.findIndex(
        (item) => item.id === action.payload.packageId,
      );
      if (index !== -1) state[index] = action.payload;
    },
    updateMarketplace: (state, action) => {
      state.marketplaceId = action.payload;
    },
    resetFilters: (state) => {
      state.search = initialState.search;
      state.pageable = initialState.pageable;
    },
    refreshPage: () => {},
  },
  extraReducers: {
    [clearReducers]: () => initialState,
  },
});

export const { name, actions, reducer } = packagesHistorySlice;
